// import { useState, useEffect } from 'react';
import { useSelector, StateProps } from 'react-redux';

function UseQuery() {
  const account = useSelector((state:StateProps) => state.account);
  return account.refetcher.me
}

export default UseQuery